import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {stategame} from '@/states/game.js';
import {statenodeplayer} from '@/states/nodeplayer.js';

// @TODO
class ScriptCoreEnd extends HYPERCUBEJS.Script {

    constructor() {

        super();
    }

    /**
     *
     * @param {*} $timebeforecollision
     * @param {HYPERCUBEJS.Node} $entity
     */
    oncollide($timebeforecollision, $entity) {

        console.log('end game')

        $entity.parent.removechild($entity);

        this.engine.destroy();

        document.getElementById('end').style.display = 'flex';
        document.body.removeChild(this.engine.deviceviewer.element);

        let resources = 0;

        if (stategame.getstate().tree === true) {

            resources += 1;
        }

        if (stategame.getstate().temple === true) {

            resources += 1;
        }

        if (stategame.getstate().mountain === true) {

            resources += 1;
        }

        const contentresources = document.getElementById('resources');
        contentresources.innerText = '' + resources;

        if (resources === 3) {

            document.getElementById('congratulations').style.display = 'block';
        }
        else {

            document.getElementById('nope').style.display = 'block';
        }
    }

    ondestroy($entity) {

        $entity.audio.pause();
    }

    onstart($entity) {

        $entity.audio.play();
        $entity.audio.loop = true;
    }

    ontick($timeframe, $entity) {

        // $entity.lookat(statenodeplayer.getstate().translation, HYPERCUBEJS.VECTOR3.create([0, 1, 0]));

        // const pertick = $timeframe / 1000;

        // $entity.rotate(HYPERCUBEJS.QUATERNION.fromeuler([
        //     0,
        //     HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick,
        //     0
        // ]));
    }
}

export {

    ScriptCoreEnd
};

export default ScriptCoreEnd;
